/* eslint-disable */
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "contents/assets/scss/page/books.scss";
import Paging from "../../component/Inc/Paging";
import Tab from "../../component/Inc/Tab";

const InOut = () => {
  const navigate = useNavigate();
  const [tabIdx, setTabIdx] = useState(0);
  const tab = [
    { title: "직접수령 요청", cnt: "64", value: 0 },
    { title: "선불발송 요청", cnt: "842", value: 1 },
    { title: "착불 발송 요청", cnt: "654", value: 2 },
    { title: "일부 발송", cnt: "45", value: 3, type: " red" },
    { title: "처리 완료과탐", cnt: "64", value: 4 },
  ];
  return (
    <main className="com_container com_books p_books_inOut">
      <div className="com_center_wrap">
        <section className="com_tit_wrap">
          <h2 className="com_pg_tit icon menu3_6">교재 불출 요청목록</h2>
        </section>
        <section className="com_pg_container">
          <section className="box full">
            <div className="com_board_list__top">
              <div className="com_btn_wrap">
                <Tab data={tab} tab={tabIdx} setTab={setTabIdx} />
                <button className="com_btn s btn_request gray">
                  내 요청(64)
                </button>
              </div>
              <section className="com_board_search">
                <article className="search">
                  <input
                    type="search"
                    placeholder="검색할 내용을 입력해 주세요."
                    className="input s type_search"
                  />
                  <button className="com_btn gray ws s icon_search"></button>
                </article>
              </section>
            </div>
            <table className="com_board_list">
              <colgroup>
                <col width="5%" />
                <col width="9%" />
                <col width="7%" />
                <col width="9%" />
                <col width="5%" />
                <col width="5%" />
                <col width="12%" />
                <col width="23%" />
                <col width="7%" />
                <col width="10%" />
              </colgroup>
              <thead>
                <tr>
                  <th>No.</th>
                  <th>
                    <button className="arrow active" />
                    요청일
                  </th>
                  <th>불출방법</th>
                  <th>요청자</th>
                  <th>과목</th>
                  <th>불출권 수</th>
                  <th>수령자</th>
                  <th>수령지</th>
                  <th>교부 대상</th>
                  <th>비고</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>45</td>
                  <td className="td_date">2022,08,25 18 : 30</td>
                  <td>
                    <button className="btn_link blue">선불발송</button>
                  </td>
                  <td>
                    <button className="btn_link">가길동201</button>
                  </td>
                  <td>수학</td>
                  <td className="td_red">20</td>
                  <td>
                    김교사103
                    <br />
                    010-1234-234
                  </td>
                  <td>경기도 수원시 수원동… 수원빌라103</td>
                  <td>
                    <button className="btn_link">홍길동103</button>
                  </td>
                  <td>
                    <button
                      onClick={() => {
                        navigate("/Books/InOut/Detail");
                      }}
                      className="btn_link blue"
                    >
                      발송 완료
                      <br />
                      2022,08,25
                    </button>
                  </td>
                </tr>
                <tr>
                  <td>45</td>
                  <td className="td_date">2022,08,25 18 : 30</td>
                  <td>
                    <button className="btn_link blue">직접수령</button>
                  </td>
                  <td>
                    <button className="btn_link">가길동201</button>
                  </td>
                  <td>수학</td>
                  <td className="td_red">20</td>
                  <td>
                    김교사103
                    <br />
                    010-1234-234
                  </td>
                  <td>경기도 수원시 수원동… 수원빌라103</td>
                  <td>
                    <button className="btn_link">홍길동103</button>
                  </td>
                  <td>
                    <button
                      onClick={() => {
                        navigate("/Books/InOut/Detail");
                      }}
                      className="btn_link red"
                    >
                      일부 발송
                      <br />
                      2023, 08 12 11:
                    </button>
                  </td>
                </tr>
                <tr>
                  <td>45</td>
                  <td className="td_date">2022,08,25 18 : 30</td>
                  <td>
                    <button className="btn_link red">착불발송</button>
                  </td>
                  <td>
                    <button className="btn_link">가길동201</button>
                  </td>
                  <td>수학</td>
                  <td className="td_red">20</td>
                  <td>
                    김교사103
                    <br />
                    010-1234-234
                  </td>
                  <td>경기도 수원시 수원동… 수원빌라103</td>
                  <td>
                    <button className="btn_link">홍길동103</button>
                  </td>
                  <td>
                    <button
                      onClick={() => {
                        navigate("/Books/InOut/Detail");
                      }}
                      className="btn_link blue"
                    >
                      발송 완료
                      <br />
                      2023. 08. 10 11:30
                    </button>
                  </td>
                </tr>
                <tr>
                  <td>45</td>
                  <td className="td_date">2022,08,25 18 : 30</td>
                  <td>
                    <button className="btn_link blue">선불발송</button>
                  </td>
                  <td>
                    <button className="btn_link">가길동201</button>
                  </td>
                  <td>수학</td>
                  <td className="td_red">20</td>
                  <td>
                    김교사103
                    <br />
                    010-1234-234
                  </td>
                  <td>경기도 수원시 수원동… 수원빌라103</td>
                  <td>
                    <button className="btn_link">홍길동103</button>
                  </td>
                  <td>
                    <button
                      onClick={() => {
                        navigate("/Books/InOut/Detail");
                      }}
                      className="btn_link blue"
                    >
                      발송 완료
                      <br />
                      2022,08,25
                    </button>
                  </td>
                </tr>
                <tr>
                  <td>45</td>
                  <td className="td_date">2022,08,25 18 : 30</td>
                  <td>
                    <button className="btn_link blue">선불발송</button>
                  </td>
                  <td>
                    <button className="btn_link">가길동201</button>
                  </td>
                  <td>수학</td>
                  <td className="td_red">20</td>
                  <td>
                    김교사103
                    <br />
                    010-1234-234
                  </td>
                  <td>경기도 수원시 수원동… 수원빌라103</td>
                  <td>
                    <button className="btn_link">홍길동103</button>
                  </td>
                  <td>
                    <button
                      onClick={() => {
                        navigate("/Books/InOut/Detail");
                      }}
                      className="btn_link blue"
                    >
                      발송 완료
                      <br />
                      2022,08,25
                    </button>
                  </td>
                </tr>
                <tr>
                  <td>45</td>
                  <td className="td_date">2022,08,25 18 : 30</td>
                  <td>
                    <button className="btn_link blue">선불발송</button>
                  </td>
                  <td>
                    <button className="btn_link">가길동201</button>
                  </td>
                  <td>수학</td>
                  <td className="td_red">20</td>
                  <td>
                    김교사103
                    <br />
                    010-1234-234
                  </td>
                  <td>경기도 수원시 수원동… 수원빌라103</td>
                  <td>
                    <button className="btn_link">홍길동103</button>
                  </td>
                  <td>
                    <button
                      onClick={() => {
                        navigate("/Books/InOut/Detail");
                      }}
                      className="btn_link blue"
                    >
                      발송 완료
                      <br />
                      2022,08,25
                    </button>
                  </td>
                </tr>
                <tr>
                  <td>45</td>
                  <td className="td_date">2022,08,25 18 : 30</td>
                  <td>
                    <button className="btn_link blue">선불발송</button>
                  </td>
                  <td>
                    <button className="btn_link">가길동201</button>
                  </td>
                  <td>수학</td>
                  <td className="td_red">20</td>
                  <td>
                    김교사103
                    <br />
                    010-1234-234
                  </td>
                  <td>경기도 수원시 수원동… 수원빌라103</td>
                  <td>
                    <button className="btn_link">홍길동103</button>
                  </td>
                  <td>
                    <button
                      onClick={() => {
                        navigate("/Books/InOut/Detail");
                      }}
                      className="btn_link blue"
                    >
                      요청
                    </button>
                  </td>
                </tr>

                {[1, 2, 3, 4, 5, 6, 7].map((i, idx) => {
                  return (
                    <tr key={idx}>
                      <td>45</td>
                      <td className="td_date">2022,08,25 18 : 30</td>
                      <td>
                        <button className="btn_link blue">선불발송</button>
                      </td>
                      <td>
                        <button className="btn_link">가길동201</button>
                      </td>
                      <td>수학</td>
                      <td className="td_red">20</td>
                      <td>
                        김교사103
                        <br />
                        010-1234-234
                      </td>
                      <td>경기도 수원시 수원동… 수원빌라103</td>
                      <td>
                        <button className="btn_link">홍길동103</button>
                      </td>
                      <td>
                        <button
                          onClick={() => {
                            navigate("/Books/InOut/Detail");
                          }}
                          className="btn_link blue"
                        >
                          발송 완료
                          <br />
                          2022,08,25
                        </button>
                      </td>
                  
                    </tr>
                  );
                })}
              </tbody>
            </table>
            <div className="com_board_list__bottom">
              <Paging />
              <div className="com_btn_wrap ">
                <button className="com_btn black xs btn_print">인쇄하기</button>
                <button className="com_btn black xs btn_down_orange">
                  다운로드
                </button>
              </div>
            </div>
          </section>
        </section>
      </div>
    </main>
  );
};

export default InOut;
